export const submitStandaloneConsent = async (payload) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    try {
        const response = await fetch('/api/consent-submit.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ ...payload, website: '', turnstileToken: '' }),
            signal: controller.signal
        });
        if (!response.ok)
            throw new Error(`Consent submission failed (${response.status})`);
        const result = (await response.json());
        if (result.registered !== true ||
            !/^CONS-\d{8}-[A-Z2-9]{6}$/.test(result.consentReference ?? '') ||
            !result.acceptedAt ||
            Number.isNaN(Date.parse(result.acceptedAt))) {
            throw new Error('Invalid consent response');
        }
        return result;
    }
    finally {
        window.clearTimeout(timeout);
    }
};
